module.exports = __webpack_public_path__ + "static/media/mobile payment.e734bb29.png";